export const SHOW_TEMPLATE = 'SHOW_TEMPLATE';
export const UPGRADE_REQUIRED = 'UPGRADE_REQUIRED';
export const DUPLICATE_THREAD = 'DUPLICATE_THREAD';
export const OPTED_OUT = 'OPTED_OUT';